/* eslint-disable */
import React, { Component } from 'react'
import AgGridTable from '../agGrid/agGridTable'
import UserModal from '../modalComponent/addUser';
import UserActionButton from './userActionButton'
export default class UserTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            update: false,
            search_value: '',
            loadingData: true,
            users: [],
            userUpdate: {},
            mode: '',
            open: false
        }
    }

    componentDidUpdate(props) {
        if (this.state.update) {
            this.setState({ update: false })
        }
    }
    getEditUserDetials = (data) => {
        let designation = data.designation.split(',')
        let newValues = [...this.state.users]
        newValues[data.id] = {
            ...newValues[data.id],
            realName: data.realName,
            designation: designation[0],
            designationCode: designation[1],
            email: data.email,
            mobileNo: data.mobileNo,
        }
        this.setState({
            users: newValues,
            open: false
        }, () => this.props.gotUserData(this.state.users))
    }
    fetchEditUserData = (data) => {
        this.setState({ userUpdate: data, mode: 'edit', open: true })
    }
    handleUserModal = () => {
        this.setState({ mode: '' })
    }
    FetchingUserData = (data, state) => {
        let userArr = [...this.state.users]
        let dataArr = []
        if (data) {
            data.map((o, i) => {
                let temp = {}
                let designation_value = o.designation.split(",")
                temp.realName = o.realName
                temp.mobileNo = o.mobileNo
                temp.id = this.state.users.length
                temp.email = o.email
                temp.designation = designation_value[0]
                temp.designationCode = designation_value[1]
                dataArr[i] = temp
            })

            if (dataArr.length > 0) {
                userArr.push(dataArr[0])
                this.setState({
                    users: userArr
                }, () => this.props.gotUserData(this.state.users))
            }
        }
        if (state) this.setState({ open: false, mode: '' })
    }

    updated = (data) => {
        if (data) {
            this.setState({ update: !this.state.update })
        }
    }
    render() {
        let preData = this.props.autoData
        let columnDefs = [
            { headerName: 'Name', field: 'realName', minWidth: 240, enableRowGroup: true, enablePivot: true },
            { headerName: 'Email', field: 'email', minWidth: 240, enableRowGroup: true, enablePivot: true },
            { headerName: 'Mobile No, ', field: 'mobileNo', minWidth: 240, enableRowGroup: true, enablePivot: true },
            { headerName: 'Designation', field: 'designationCode', minWidth: 240, enableRowGroup: true, enablePivot: true },
            { headerName: 'Edit', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true },
        ]
        // { console.log("Users : ", this.state.users) }
        return (
            <div>
                <AgGridTable
                    isLoading={this.state.loadingData}
                    columnDefs={columnDefs}
                    rowData={this.state.users}
                    hiddenOEBtn={true}
                    hiddenNew={true}
                    getEditUserDetials={this.fetchEditUserData}
                    pagination={true}
                    moreTitleComponents={
                        <UserModal
                            openBox={this.state.openUserBox}
                            getEditUserData={this.getEditUserDetials}
                            updated={this.props.updated}
                            handleClose={this.handleUserClose}
                            editUserDetails={this.state.userUpdate}
                            mode={this.state.mode}
                            openUserModal={this.handleUserModal}
                            onClose={() => this.setState({ open: false })}
                            onOpen={() => this.setState({ open: true })}
                            open={this.state.open}
                            getuserdata={this.FetchingUserData} />
                    }
                    exporthidden={true}
                    importhidden={true}
                    searchbar={true}
                    loading={this.state.loading}
                    serverData={this.state.users}
                    titleBarTitle={"User Details"}
                    actionButton={UserActionButton}
                    updated={this.updated}
                    baseURL={this.props.locationHistory}
                />
            </div>
        )
    }
}
